import { useParams, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import "./VoadorPage.css";
import People from "../(home)/People";
import { findArtistBySlug } from "../../data/artists";
import { getIllustrationsByArtist } from "../../data/illustrations";
import { getPhotosByArtist } from "../../data/photos";
import { Link } from "react-router-dom";

// Quantas fotos aparecem de início, e quantas a mais a cada clique em "Ver mais"
const PHOTOS_PAGE_SIZE = 12;

export default function VoadorPage() {
  const { name } = useParams<{ name: string }>();
  const navigate = useNavigate();
  const [visiblePhotos, setVisiblePhotos] = useState(PHOTOS_PAGE_SIZE);

  // Scroll to top when component mounts
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  // Ao trocar de voador (a rota é a mesma e o componente é reaproveitado),
  // volta a mostrar só a primeira página de fotos
  useEffect(() => {
    setVisiblePhotos(PHOTOS_PAGE_SIZE);
  }, [name]);

  // procura pelo colaborador na URL (aceita o id do artista ou o nome normalizado)
  const collaborator = findArtistBySlug(name);

  // Ilustrações e fotos do artista, vindas de birds.ts (via data/illustrations e data/photos)
  const artistIllustrations = collaborator
    ? getIllustrationsByArtist(collaborator.id)
    : [];
  const artistPhotos = collaborator ? getPhotosByArtist(collaborator.id) : [];

  if (!collaborator) {
    return (
      <div className="voador-page not-found">
        {/* Not Found Content */}
        <div className="not-found-content">
          <h1 className="not-found-title">Colaborador não encontrado</h1>
          <p className="not-found-description">
            O colaborador que você está procurando não existe ou foi removido de
            nossa equipe.
          </p>
          <div className="not-found-actions">
            <button
              className="not-found-button secondary"
              onClick={() => navigate("/")}
            >
              Voltar ao início
            </button>
            <button
              className="not-found-button primary"
              onClick={() => {
                navigate("/");
                setTimeout(() => {
                  const peopleSection =
                    document.querySelector(".people-container");
                  if (peopleSection) {
                    peopleSection.scrollIntoView({ behavior: "smooth" });
                  }
                }, 100);
              }}
            >
              Ver todos os colaboradores
            </button>
          </div>
        </div>
      </div>
    );
  }

  const displayName = collaborator.fullName ?? collaborator.name;

  return (
    <div className="voador-page">
      {/* Back Button */}
      <button
        className="voador-back-button"
        onClick={() => navigate("/")}
        aria-label="Voltar"
      >
        <span>←</span>
        <span>Voltar</span>
      </button>

      {/* Profile Section */}
      <section className="voador-profile">
        <div className="profile-image">
          <img
            src={collaborator.image ?? "/pfps/anon.png"}
            alt={displayName}
          />
        </div>
        <div className="profile-info">
          <h2 className="profile-name">{displayName}</h2>
          {collaborator.role && (
            <h3 className="profile-role">{collaborator.role}</h3>
          )}
          {collaborator.description && (
            <p className="profile-bio">{collaborator.description}</p>
          )}
        </div>
      </section>

      {/* Illustrations */}
      {artistIllustrations && artistIllustrations.length > 0 && (
        <section className="voador-illustrations">
          <h2 className="people-title">Ilustrações</h2>
          <div className="illustrations-container">
            {artistIllustrations.map((item) => (
              <div key={item.src} className="illustration-item">
                <Link to={`/ilustracoes?bird=${item.bird.id}&img=${item.index}`}>
                  <img
                    src={item.src}
                    alt={item.name}
                    title={`${item.name} (${item.bird.scientificName})`}
                  />
                </Link>
              </div>
            ))}
          </div>
        </section>
      )}

      {/* Photos */}
      {artistPhotos.length > 0 && (
        <section className="voador-photos">
          <h2 className="people-title">Fotos</h2>
          <div className="voador-photos-grid">
            {artistPhotos.slice(0, visiblePhotos).map((item) => (
              <div key={item.src} className="voador-photo-item">
                <Link to={`/fotos?bird=${item.bird.id}&img=${item.index}`}>
                  <img
                    src={item.src}
                    alt={`${item.name} (${item.bird.scientificName})`}
                    title={`${item.name} (${item.bird.scientificName})`}
                    loading="lazy"
                    decoding="async"
                  />
                </Link>
              </div>
            ))}
          </div>
          {artistPhotos.length > visiblePhotos && (
            <button
              className="voador-photos-more"
              onClick={() =>
                setVisiblePhotos((current) => current + PHOTOS_PAGE_SIZE)
              }
            >
              Ver mais fotos ({artistPhotos.length - visiblePhotos} restantes)
            </button>
          )}
        </section>
      )}

      {/* Voadores Carousel */}
      <section className="voador-carousel">
        <People onPersonClick={() => window.scrollTo(0, 0)} />
      </section>
    </div>
  );
}
